/* v59: retired. The "Package Protection only" check now lives inline in
   snippets/ice-freaks-head.liquid, so a cached copy of an old version of this
   file can never block checkout again. This file only cleans up. */
(function(){
function clean(){var m=document.getElementById('if-guard-msg');if(m)m.remove();}
clean();setInterval(clean,1000);
})();
